import React from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import InputField from "./InputField";
import "../css/loginform.css";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../api/authContext";
import { Users, TrendingUp, BarChart3, Shield } from "lucide-react";
import ZenLogo from "../assets/images/ZEN LOGO-w 1.png";

const API_URL = "https://apicrm.zenrealestate.in/api";

const features = [
  { icon: Users,      text: "Manage leads, agents, and site visits in one place" },
  { icon: TrendingUp, text: "Track deals from negotiation to closure" },
  { icon: BarChart3,  text: "Detailed MIS reports and performance analytics" },
  { icon: Shield,     text: "Role-based access for Super Admin, Manager & Agents" },
];

const validationSchema = Yup.object({
  email:    Yup.string().email("Invalid email format").required("Email is required"),
  password: Yup.string().min(6, "Password must be at least 6 characters").required("Password is required"),
});

export const Loginform = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await axios.post(`${API_URL}/auth/login`, values);
      const { token, name, email, role, emailVerified } = response.data;

      login({ token, role, name, email: email || values.email, emailVerified });

      toast.success("Login successful!", { position: "top-right", autoClose: 2000, theme: "colored" });
      setTimeout(() => navigate("/dashboard"), 1200);
    } catch (err) {
      toast.error(err.response?.data?.message || "Login failed. Please check your credentials.", {
        position: "top-right", autoClose: 4002, theme: "colored",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-wrapper">
      {/* â”€â”€ Left brand panel â”€â”€ */}
      <div className="login-left">
        <div className="login-brand">
          <img src={ZenLogo} alt="Zen Realty" className="login-brand-logo" />
          <h1>Your Real Estate<br />CRM Platform</h1>
          <p>
            A complete internal management system for your sales team — from lead
            capture to deal closure, all in one professional workspace.
          </p>
        </div>

        <div className="login-features">
          {features.map(({ icon: Icon, text }, i) => (
            <div className="login-feature-item" key={i}>
              <div className="login-feature-icon">
                <Icon size={18} />
              </div>
              <span>{text}</span>
            </div>
          ))}
        </div>

        <p className="login-left-footer">
          Â© {new Date().getFullYear()} Zen Realty â€” Internal Use Only
        </p>
      </div>

      {/* â”€â”€ Right form panel â”€â”€ */}
      <div className="login-right">
        <div className="login-form">
          <div className="login-form-header">
            <h2 className="welcome-text">Welcome Back</h2>
            <p className="subtitle">Sign in to your ZENREAL ESTATES CRM account</p>
          </div>

          <Formik
            initialValues={{ email: "", password: "" }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <InputField label="Email Address" name="email" type="email" placeholder="you@zenrealty.co" />
                <InputField label="Password" name="password" type="password" placeholder="Enter your password" />

                <div className="form-options">
                  <Link to="/forgot-password">Forgot Password?</Link>
                </div>

                <button type="submit" className="signIn-btn" disabled={isSubmitting}>
                  {isSubmitting ? "Signing inâ€¦" : "Sign In"}
                </button>
              </Form>
            )}
          </Formik>

          <p className="footer-text">
            Need an account?<Link to="/register">Create one now</Link>
          </p>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};
